import { render, staticRenderFns } from "./ModalHistoricoCobrancaAssinaturaRegistro.vue?vue&type=template&id=0812324d&scoped=true"
import script from "./ModalHistoricoCobrancaAssinaturaRegistro.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoCobrancaAssinaturaRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0812324d",
  null
  
)

export default component.exports